import createNotification from './createNotification';

export const VIEW_AS_BUYER_HEADER = 'X-View-As-BuyerUserId';

const viewAsBuyerPathPattern = /^\/connect\/view-as\/(\d+)(\/|$)/;

export const getActiveViewAsBuyerUserId = (
    pathname: string = window.location.pathname
): string | null => {
    const match = pathname.match(viewAsBuyerPathPattern);
    return match ? match[1] : null;
};

export const isViewAsBuyerActive = (pathname?: string): boolean => {
    return getActiveViewAsBuyerUserId(pathname) !== null;
};

export const notifyViewAsBuyerReadOnly = (): void => {
    createNotification(
        'View as Buyer is read-only — this action is not allowed.',
        'warning'
    );
};
